export default function LightArc() {
  return (
    <div aria-hidden="true" className="absolute inset-0 overflow-hidden pointer-events-none">
      <div
        className="absolute"
        style={{
          top: "-35%",
          right: "-20%",
          width: "70%",
          height: "115%",
          background: "radial-gradient(ellipse at 78% 18%, rgba(0,207,255,0.22) 0%, rgba(29,111,242,0.16) 30%, rgba(29,111,242,0.05) 52%, transparent 70%)",
          filter: "blur(30px)",
          transform: "rotate(-10deg)",
        }}
      />
      <div
        className="absolute"
        style={{
          top: "-12%",
          right: "2%",
          width: "48%",
          height: "64%",
          background: "radial-gradient(ellipse at 70% 25%, rgba(127,217,255,0.32) 0%, rgba(46,155,255,0.14) 42%, transparent 68%)",
          filter: "blur(38px)",
          transform: "rotate(-14deg)",
        }}
      />
      <div
        className="absolute"
        style={{
          top: "4%",
          right: "-8%",
          width: "60%",
          height: 90,
          background: "linear-gradient(90deg, transparent 0%, rgba(46,155,255,0.14) 35%, rgba(127,217,255,0.32) 62%, rgba(46,155,255,0.08) 85%, transparent 100%)",
          filter: "blur(16px)",
          transform: "rotate(-24deg)",
          transformOrigin: "top right",
        }}
      />
    </div>
  );
}
